import { render } from "./ElementaryProgram.vue?vue&type=template&id=3d0510dc"
import script from "./ElementaryProgram.vue?vue&type=script&lang=js"
export * from "./ElementaryProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__